/* eslint-disable react/require-default-props */
import React from 'react';
import proptypes from 'prop-types';
import { ImpressionProvider } from '@thd-olt-component-react/impression';

const { bool, number: numberType, string: stringType } = proptypes;

/*
 * This is a Higher Order Component (HOC) that returns the component wrapped in an ImpressionProvider.
 */
const withImpressions = (Component) => {
  const Sub = ({
    componentClass = '', componentId, componentPosition = 1, lazyLoad = false, enableB2CRadius = false
  }) => {
    return (
      <ImpressionProvider
        data={{
          id: componentId,
          name: 'InternalMarketingBanner',
          component: 'InternalMarketingBanner',
          type: 'content'
        }}
      >
        <Component
          componentClass={componentClass}
          componentId={componentId}
          componentPosition={componentPosition}
          lazyLoad={lazyLoad}
          enableB2CRadius={enableB2CRadius}
        />
      </ImpressionProvider>
    );
  };

  Sub.propTypes = {
    componentClass: stringType,
    componentId: stringType.isRequired,
    componentPosition: numberType,
    lazyLoad: bool,
    enableB2CRadius: bool
  };

  return Sub;
};

export { withImpressions };
